module.exports = __webpack_public_path__ + "media/circlemonkey.27fce021.mp3";